<form class="filter" [formGroup]="braintreeMatchingFilterForm" (submit)="applyBraintreeMatchingFilters()">
    <modal-panel
        data-testid="braintree-matching-vcc-filter-modal-panel"
        class="braintree-matching-vcc-filter-modal-panel-cls filter-panel"
        title="Filter"
        (close)="closeForm();"
        >
            <div data-testid="braintree-matching-vcc-filter-modal-div-2" class="filter__fields">
                <mat-grid-list class="modal-filter-col-flex" [cols]="isSmall ? 1 : 2" gutterSize="10px" rowHeight="85">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Release date from</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="releasedDateFrom">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            @if(braintreeMatchingFilterForm.controls['releasedDateFrom'].value){
                                <button 
                                    data-testid="braintree-matching-vcc-release-date-from-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearMatchingFields('releasedDateFrom')">
                                        <mat-icon>close</mat-icon>
                                </button>
                            } @else {
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                            }
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Release date to</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="releasedDateTo">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-datepicker #picker2></mat-datepicker>
                            @if(braintreeMatchingFilterForm.controls['releasedDateTo'].value){
                                <button 
                                    data-testid="braintree-matching-vcc-release-date-to-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearMatchingFields('releasedDateTo')">
                                        <mat-icon>close</mat-icon>
                                </button>
                            } @else {
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                            }
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Last four cc</mat-label>
                            <input matInput placeholder="Last four cc" value="" formControlName="lastFourCC" maxlength="4" (keypress)="checkInput($event)">
                            @if(braintreeMatchingFilterForm.controls['lastFourCC'].value){
                                <button 
                                    data-testid="braintree-matching-vcc-last-four-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearMatchingFields('lastFourCC')">
                                        <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <dynamic-autocomplete
                            [formControl]="adxTripReferenceControl"
                            [formLabel]="'Adx Trip Reference'"
                            [tableName]="'BraintreeTramsBookingJoinModel'"
                            [columnName]="'OrderNumber'"
                            [emitString]="true"
                            [dataTestId]="'braintree-matching-vcc-adx-trip-reference'"
                        ></dynamic-autocomplete>
                    </mat-grid-tile>

                </mat-grid-list>
                <mat-grid-list cols="1" gutterSize="10px" rowHeight="85">
                    <mat-grid-tile>
                        <div style="width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px;">
                            <p style="margin: 0; font-size: 14px; flex: 0 0 auto; min-width: 120px;">Matched VCC's</p>
                            <div style="display: flex; justify-content: center; align-items: center; flex: 1;">
                                <mat-radio-group formControlName="isMatched" aria-label="is-matched" [color]="'primary'" style="display: flex; gap: 24px;">
                                    <mat-radio-button [value]="true" style="margin: 0;">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false" style="margin: 0;">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <button 
                                data-testid="braintree-matching-vcc-is-matched-clear-filter-button"
                                mat-icon-button
                                type="button"
                                style="flex: 0 0 auto;"
                                (click)="clearMatchingFields('isMatched')">
                                    <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
            <ng-container data-testid="braintree-matching-vcc-modal-footer-container" modalPanelFooter>
                <div class="modal-footer">
                    <button data-testid="braintree-matching-vcc-filter-modal-button-clear-all" mat-stroked-button color="primary" type="button" (click)="clearMatchingFields()">
                        <mat-icon data-testid="braintree-matching-vcc-filter-clear-all-filter-button-icon">delete_outline</mat-icon>
                        Clear All
                    </button>
                    <button data-testid="braintree-matching-vcc-modal-button" mat-raised-button color="primary" type="submit" (click)="applyBraintreeMatchingFilters()">Apply</button>
                </div>
            </ng-container>
    </modal-panel>
    </form>
